import list from './list';
import edit from './edit';

const module = {
  namespaced: true,
  modules: {
    list,
    edit,
  },
};

export default module;
